import React from "react";

import * as S from "./styles";
import ChannelTalkBoot from "../ChannelTalk/channel-talk-boots";

const Layout = ({ children }: { children: React.ReactNode }) => (
  <>
    <ChannelTalkBoot />
    <S.Container>{children}</S.Container>
  </>
);

export default Layout;
